export enum ClinicalCasePrivacy {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
